import React, { useState } from "react";
import logo from "../assets/logos/2-Photoroom.png";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="navbar">
        <div className="navbar-container">

          {/* LOGO */}
          <div className="brand">
            <img
              src={logo}
              alt="The Culture Capsule"
              className="logo"
            />
          </div>

          {/* DESKTOP NAV */}
          <ul className="nav-links">
            <li>
              <a href="#projects" className="name">
                Culture at Work
              </a>
            </li>

            <li>
              <a href="#team-section" className="name">
                Culture Makers
              </a>
            </li>

            <li>
              <a href="#about" className="name">
                Our Culture
              </a>
            </li>

            <li>
              <a href="#services" className="name">
                The Culture Kit
              </a>
            </li>

            <li>
              <a href="#careers" className="name">
                Careers
              </a>
            </li>

            <li>
              <a href="#contact" className="name">
                Connect with Culture
              </a>
            </li>
          </ul>

          {/* MOBILE MENU ICON */}
          <button
            className="menu-icon"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            ☰
          </button>

        </div>
      </nav>

      {/* ================= MOBILE OVERLAY ================= */}
      <div className={`menu-overlay ${menuOpen ? "active" : ""}`}>

        {/* MENU HEADER */}
        <div className="menu-header">

          <img
            src={logo}
            alt="The Culture Capsule"
            className="mobile-logo"
          />

          <button
            className="menu-close"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            ✕
          </button>

        </div>

        {/* MOBILE LINKS */}
        <div className="menu-links">

          <a href="#projects" className="name" onClick={closeMenu}>
            Culture at Work
          </a>

          <a href="#team-section" className="name" onClick={closeMenu}>
            Culture Makers
          </a>

          <a href="#about" className="name" onClick={closeMenu}>
            Our Culture
          </a>

          <a href="#services" className="name" onClick={closeMenu}>
            The Culture Kit
          </a>

          <a href="#careers" className="name" onClick={closeMenu}>
            Careers
          </a>

          <a href="#contact" className="name" onClick={closeMenu}>
            Connect with Culture
          </a>

        </div>

        {/* FOOTER CTA */}
        <div className="menu-footer">
          <a
            href="#contact"
            className="menu-cta"
            onClick={closeMenu}
          >
            • Get in Touch
          </a>
        </div>

      </div>
    </>
  );
}

export default Navbar;